import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.get-own-property-names.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Empty } from 'ant-design-vue';
import { updateIsRead } from '@/services/flow';
export default {
  props: {
    mainList: {
      type: [],
      default: ''
    },
    mainList1: {
      type: [],
      default: ''
    },
    showLoading: {
      type: Boolean
      // default: ''
    },
    showLoading1: {
      type: Boolean
      // default: ''
    }
  },
  data: function data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      dbDot: false,
      ybDot: false,
      dyDot: false,
      yyDot: false,
      daibanList: [],
      yibanList: [],
      daiyueList: [],
      yiyueList: [],
      loadings: false,
      loadings1: false,
      mainLeftIndex: 0,
      mainRightIndex: 0,
      typeIndex: '',
      allList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    //判断数据是否有新增
    // if (this.mainList) {
    //     console.log(this.mainList, 'mainList有值');
    //     if (this.mainList[0].typeIndex == 0) {
    //         console.log('没进来？？？？');
    //         var dblist = JSON.parse(localStorage.getItem('dbList'));
    //         console.log(dblist, '================dblist');
    //         console.log(this.daibanList, '===========daibanlist');
    //         this.dbCompareArray(dblist, this.daibanList);
    //         this.ybCompareArray(this.yibanList, this.mainList[0].list1);
    //     }
    // }
    // if (this.mainList1) {
    //     console.log(this.mainList1, 'mainList1有值');
    //     if (this.mainList1[0].typeIndex == 1) {
    //         this.dyCompareArray(this.daiyueList, this.mainList1[0].daiyueList);
    //         this.yyCompareArray(this.yiyueList, this.mainList1[0].yiyueList);
    //     }
    // }

    if (this.mainList) {
      this.mainList.forEach(function (item) {
        _this.typeIndex = item.typeIndex;
      });
    }
    if (this.mainList1) {
      this.mainList1.forEach(function (item) {
        _this.typeIndex = item.typeIndex;
      });
    }
  },
  methods: {
    refresh: function refresh(data) {
      this.daibanList = data;
      var dblist = JSON.parse(localStorage.getItem('dbList'));
      this.dbCompareArray(dblist, this.daibanList);
    },
    refresh2: function refresh2(data) {
      this.yibanList = data;
      var yibanList = JSON.parse(localStorage.getItem('yibanList'));
      this.ybCompareArray(yibanList, this.yibanList);
    },
    refresh1: function refresh1(data) {
      var _this2 = this;
      this.daiyueList = [];
      this.yiyueList = [];
      // this.allList = data
      data.forEach(function (item, index) {
        if (item.isRead == 2) {
          _this2.yiyueList.push(item);
        } else {
          //未读
          _this2.daiyueList.push(item);
        }
      });
      var dylist = JSON.parse(localStorage.getItem('dyList'));
      this.dyCompareArray(dylist, this.daiyueList);
    },
    /**
     * 判断代办数组是否相同
     */
    dbCompareArray: function dbCompareArray(a1, a2) {
      if (a1 == null && a2.length == 0) {
        this.dbDot = false;
      } else if (this.compareArray(a1, a2)) {
        this.dbDot = false;
      } else {
        //不同
        this.dbDot = true;
      }
      this.daibanList = a2;
      localStorage.setItem('dbList', JSON.stringify(a2));
    },
    /**
     * 判断已办数组是否相同
     */
    ybCompareArray: function ybCompareArray(a1, a2) {
      if (a1 == null && a2.length == 0) {
        this.ybDot = false;
      } else if (this.compareArray(a1, a2)) {
        this.ybDot = false;
      } else {
        this.ybDot = true;
      }
      this.yibanList = a2;
      localStorage.setItem('yibanList', JSON.stringify(a2));
    },
    /**
     * 判断待阅数组是否相同
     */
    dyCompareArray: function dyCompareArray(a1, a2) {
      if (a1 == null && a2.length == 0) {
        this.ybDot = false;
      } else if (this.compareArray(a1, a2)) {
        this.dyDot = false;
      } else {
        //不同
        this.dyDot = true;
      }
      this.daiyueList = a2;
      localStorage.setItem('dyList', JSON.stringify(a2));
    },
    /**
     * 判断已阅数组是否相同
     */
    yyCompareArray: function yyCompareArray(a1, a2) {
      if (a1 == null && a2.length == 0) {
        this.ybDot = false;
      } else if (this.compareArray(a1, a2)) {
        this.yyDot = false;
      } else {
        //不同
        this.yyDot = true;
      }
      this.yiyueList = a2;
    },
    /**
     * 判断两个数组是否相同
     */
    compareArray: function compareArray(a1, a2) {
      if (a1 === a2) return true;
      if (!a1 && a2 || a1 && !a2) {
        return false;
      }
      if (a1.length != a2.length) {
        return false;
      }
      if (toString.call(a1) == '[object Object]' || toString.call(a2) == '[object Object]') {
        for (var i = 0, n = a2.length; i < n; i++) {
          var propsA = Object.getOwnPropertyNames(a1[i]),
            propsB = Object.getOwnPropertyNames(a2[i]);
          for (var a = 0; a < propsB.length; a++) {
            if (a1[i][propsA[a]] != a2[i][propsB[a]]) {
              return false;
            } else {
              return true;
            }
          }
        }
      }
      return true;
    },
    applyAudit: function applyAudit(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/auditProcess',
        query: {
          procInsId: record.procInsId,
          taskId: record.taskId,
          path: 'waitMeApplication'
        }
      });
    },
    onViewAfterMeApply: function onViewAfterMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.procInsId
        }
      });
    },
    /**
     * 待办查看
     */
    toView: function toView(item) {
      this.$router.push({
        path: '/dashboard/workAuditProcess',
        query: {
          procInsId: item.procInsId,
          taskId: item.taskId
        }
      });
    },
    /**
     * 已阅查看
     */
    toViewCopy: function toViewCopy(item) {
      //修改查看状态
      updateIsRead({
        copyId: item.copyId
      }).then(function (res) {});
      this.$router.push({
        path: '/dashboard/workViewProcess',
        query: {
          procInsId: item.processInstanceId
        }
      });
    },
    /**
     * 待办已办切换
     */
    changeMainIndex: function changeMainIndex(e) {
      if (e == 0) {
        this.daibanList = [];
        // this.dbDot = false;
        this.$parent.getToDoList();
      } else {
        this.yibanList = [];
        this.$parent.finishedList();
        // this.ybDot = false;
      }
      this.mainLeftIndex = e;
    },
    /**
     * 待阅已阅切换
     */
    changeMainRightIndex: function changeMainRightIndex(e) {
      if (e == 0) {
        // this.dyDot = false;
        this.daiyueList = [];
        this.$parent.getFlowCopyMan();
      } else {
        this.yiyueList = [];
        // this.yyDot = false;
        this.$parent.getFlowCopyMan();
      }
      this.mainRightIndex = e;
    },
    /**
     * 跳转至待办页面
     */
    toWaitdo: function toWaitdo() {
      this.$router.push('/dashboard/waitdo');
    },
    handleLoading: function handleLoading() {
      var _this3 = this;
      this.loadings = true;
      if (this.mainLeftIndex == 0) {
        this.$parent.getToDoList();
      } else {
        this.$parent.getToDoList();
      }
      setTimeout(function () {
        _this3.loadings = false;
      }, 1000);
    },
    handleLoading1: function handleLoading1() {
      var _this4 = this;
      this.loadings1 = true;
      if (this.mainRightIndex == 0) {
        this.$parent.getFlowCopyMan();
      } else {
        this.$parent.getFlowCopyMan();
      }
      setTimeout(function () {
        _this4.loadings1 = false;
      }, 1000);
    }
  }
};